/* ============================================================
   MCC R2 (10/2026) · Homepage behaviour. mcc-home.js (deferred).
   Linked by sections/mcc-home-looks.liquid and sections/mcc-home-countdown.liquid;
   the guard below makes a second <script> tag a no-op.
   1. Looks strip (desktop): the arrow buttons scroll the strip by 80% of its width
      (no autoplay; instant scroll with prefers-reduced-motion). The strip gets .is-end
      at its right end, which drops the 64px fade so the last arch is not dimmed.
   2. Countdown: days until Dec 25 by the visitor's calendar, replacing the server number.
   3. Visit tiles (phone/tablet): equal text height for Stay + Plano only when their line counts differ.
   Re-runs for a section the theme editor re-renders (shopify:section:load).
   ============================================================ */
(function () {
  'use strict';
  if (window.mccHomeReady) return;
  window.mccHomeReady = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRails(root) {
    var buttons = root.querySelectorAll('[data-mh-rail]');
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.getAttribute('data-mh-ready')) return;
        btn.setAttribute('data-mh-ready', '1');
        btn.addEventListener('click', function () {
          var rail = document.getElementById(btn.getAttribute('data-mh-rail'));
          if (!rail) return;
          var left = Number(btn.getAttribute('data-mh-dir')) * rail.clientWidth * 0.8;
          if (typeof rail.scrollBy === 'function') {
            rail.scrollBy({ left: left, behavior: reduce ? 'auto' : 'smooth' });
          } else {
            rail.scrollLeft += left;
          }
        });
      })(buttons[i]);
    }
    var rails = root.querySelectorAll('.mh-looks__row');
    for (var j = 0; j < rails.length; j++) {
      (function (rail) {
        if (rail.getAttribute('data-mh-ready')) return;
        rail.setAttribute('data-mh-ready', '1');
        var queued = false;
        function update() {
          queued = false;
          var end = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          rail.classList.toggle('is-end', end);
        }
        function queue() {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(update);
        }
        rail.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        update();
      })(rails[j]);
    }
  }

  function initCountdown(root) {
    var els = root.querySelectorAll('[data-mh-countdown]');
    if (!els.length) return;
    var now = new Date();
    var y = now.getFullYear();
    var xmas = new Date(y, 11, 25);
    if (now >= xmas) xmas = new Date(y + 1, 11, 25);
    var days = Math.round((xmas - new Date(y, now.getMonth(), now.getDate())) / 864e5);
    if (!(days >= 0 && days < 400)) return;
    for (var i = 0; i < els.length; i++) els[i].textContent = String(days);
  }

  // 3. Visit tiles (phone + tablet): Stay and Plano sit side by side with their copy anchored to the bottom.
  //    When one text block wraps to more lines, both get that height so the two titles still line up;
  //    when they match (most phones), nothing is reserved and the copy sits right at the bottom. Kyle 10/19.
  var narrow = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  function equalizeVisit() {
    var grids = document.querySelectorAll('.mh-visit .mh-visit__grid');
    for (var g = 0; g < grids.length; g++) {
      var texts = grids[g].querySelectorAll('.mh-tile:not(.mh-tile--wide):not(.mh-tile--row) .mh-tile__text');
      var k, max = 0;
      for (k = 0; k < texts.length; k++) texts[k].style.minHeight = '';
      if (!narrow || !narrow.matches || texts.length < 2) continue;
      for (k = 0; k < texts.length; k++) max = Math.max(max, texts[k].getBoundingClientRect().height);
      for (k = 0; k < texts.length; k++) texts[k].style.minHeight = Math.ceil(max) + 'px';
    }
  }
  var eqQueued = false;
  function queueEqualize() {
    if (eqQueued) return;
    eqQueued = true;
    window.requestAnimationFrame(function () { eqQueued = false; equalizeVisit(); });
  }
  window.addEventListener('resize', queueEqualize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueEqualize);

  function init(root) {
    initRails(root);
    initCountdown(root);
    queueEqualize();
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
